import {defineSlotRecipe} from '@chakra-ui/react3'

export const galleryRecipe = defineSlotRecipe({
    slots: ['mainContainer', 'thumbsContainer', 'galleryContainer', 'wishlistButtonContainer'],
    base: {
        mainContainer: {
            position: 'relative',
            height: '100%',
            flexDir: {base: 'column', s: 'row'},
            paddingInline: {base: 'spacing-24', s: 0},
            gap: {s: 'spacing-16'}
        },
        thumbsContainer: {
            position: 'relative',
            display: {base: 'none', s: 'flex'},
            width: 'spacing-90',
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: 'spacing-90'
        },
        galleryContainer: {
            position: 'relative',
            flex: {base: 'none', s: '1'},
            px: {base: 0, s: 0},
            minW: 0,
            height: '100%',
            aspectRatio: 1,
            bg: 'bg'
        },
        wishlistButtonContainer: {
            position: 'absolute',
            top: 'spacing-16',
            right: 'spacing-16',
            zIndex: 'overlay',
            pointerEvents: 'auto'
        }
    }
})
